var HttpFormError = (function () {
    function HttpFormError() {
        this.error = false;
    }
    HttpFormError.prototype.setError = function (error) {
        if (error.response !== undefined) {
            this.error = error.response;
        }
        throw this.getErrorMessage();
    };
    HttpFormError.prototype.hasErrorOccurred = function () {
        return this.error !== false;
    };
    HttpFormError.prototype.getErrorMessage = function () {
        var message = 'An unexpected error occurred, please contact support.';
        if (this.error !== false) {
            var data = this.error.data;
            return data.message ? data.message : message;
        }
        return message;
    };
    HttpFormError.prototype.resetErrorStatus = function () {
        this.error = false;
    };
    HttpFormError.prototype.fieldHasErrors = function (field) {
        if (this.error !== false && this.error.data.errors) {
            return this.error.data.errors.hasOwnProperty(field);
        }
        return false;
    };
    HttpFormError.prototype.getFieldError = function (field) {
        if (this.error !== false && this.fieldHasErrors(field)) {
            return this.error.data.errors[field][0];
        }
        return false;
    };
    return HttpFormError;
}());
export { HttpFormError };
